export default __webpack_public_path__ + "static/offer-1d6b5d7a70aa4f9c8f45e85b7c6f2b3d.jpg";